export default __webpack_public_path__ + "static/media/WIBS.7180a3ea.png";